<template>
    <div class="zenWrap" :class="item.containerClass">
        <div><i @click="item.toggleShowChildObjects()" class='clC' :class="item.showChildObjects ? 'bi-eye-fill' : 'bi-eye'" style="font-size: 1rem;"></i><span @click="item.toggleShowHex()" class="ms-1 clC" :class="item.showHex ? 'fw-bold'  : ''" style="font-size: 1.1rem;">0x</span><i @click="item.saveFile()" class='ms-1 me-2 bi-download clC' style="font-size: 1rem;"></i>
            <span class="noWR" v-if="item.block!=null"><b>Block Name:</b>{{item.block.name}}&nbsp;</span>
            <span class="noWR" v-if="item.displayChildIndex"><b>Child Index:</b>{{$filters.hex16(index)}}&nbsp;</span>
            <span class="noWR"><b>Start:</b>{{ $filters.hex24(item.start)}}</span> <span class="noWR"><b>Length</b>:{{$filters.hex24(item.length)}}</span></div>
        <div v-if="item.displayInformation!=null"><span v-for="(value,name) in item.displayInformation" :key="item.uid+name"><b>{{name}}:</b><span v-if="typeof value === 'number'">{{$filters.hex32(value)}}</span><span v-else>{{value}}</span>&nbsp;</span></div>
        <component :item="item" :key="item.uid" :is="item.componentName" v-if="item.componentName!=='ZenDataComponent'"></component>
       <div class="hexArea" v-if="item.showChildObjects && item.showHex && item.hex()!=null" v-html="item.hex()">
        </div>
        <div class="zenIndent children" v-if="item.children!=null && item.showChildObjects" :class="item.children.length!=1 ? 'zenWrap manyChildren' :''">
                <ZenDataComponent class="mb-2" v-for="(item,itemIndex) in item.children" :item="item" :index="itemIndex" :key="item.uid"></ZenDataComponent>
        </div>
        <div class="paramArea" v-if="item.hasParameterView()" v-html="item.parameterView()">
            </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    name: 'ZenDataComponent',
    components: {
    },
    props: [
        'item',
        'index'
    ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
